import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Util } from '../../../../utils/util';
import { PixDevolutionRequest } from '../../models/devolution-request.mode';
import { PixTransaction } from '../../models/transaction.model';
import { PixRefundService } from '../refund.service';
import { SharedService } from '../../../../shared/shared.service';
import { debounceTime } from 'rxjs/operators';
@Component({
	selector: 'app-pix-refund-value',
	templateUrl: './value.component.html',
	styleUrls: ['./value.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixRefundValueComponent implements OnInit {

	public form: FormGroup;
	public transaction: PixTransaction;
	balanceCalculated: number;
	transactionValue: number;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private refundService: PixRefundService,
		private sharedService: SharedService
	) { }

	ngOnInit(): void {
		this.buildForm();
		this.transaction = this.refundService.getPixTransaction();

		if (this.transaction && this.transaction.valor) {
			this.updateForm();
		} else {
			this.router.navigate(['pix/']);
		}
		this.getBalance();
	}

	getBalance() {
		this.sharedService.getBalance().subscribe((data: any) => {
			this.balanceCalculated = data.Retorno.SaldoParcial;
			this.updateForm();
		});
	}

	buildForm() {
		this.form = this.formBuilder.group({
			value: ['', [Validators.required]],
			description: ['', [Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)]],
		});
	}

	updateForm() {
		this.transactionValue = this.balanceCalculated < this.transaction.valor ? this.balanceCalculated : this.transaction.valor;
		this.form.get('value').setValue(this.transactionValue);
		this.form.get('value').setValidators([Validators.required, Validators.min(0.01), Validators.max(this.transactionValue)]);
		this.form.get('value').updateValueAndValidity();
	}

	generate() { }

	goBack() {
		this.router.navigate(['pix/']);
	}

	submit() {
		if (this.form.valid) {
			const request = new PixDevolutionRequest();
			request.descricao = this.form.get('description').value;
			request.numeroOrigem = null;
			request.codigoTransacao = this.transaction.advanced.codigoTransacao;
			request.valor = this.form.get('value').value;
			request.tipoCanalIniciacao = null;
			request.codigoRequisicao = Util.generateGUID();
			request.dataAgendamento = null;
			request.horaAgendamento = null;
			request.nome = this.transaction.nome;

			this.refundService.setPixDevolutionRequest(request);
			this.router.navigate(['pix/devolver/assinatura']);
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/refund/value/value.component.ts